import {
  createStandardAction,
  createReducer,
  ActionType,
  StateType
} from "typesafe-actions";
import _ from "lodash";

type SettingChangePayload = {
  category: string;
  subcategory: string;
  collection: string;
  settingName: string;
  change: Change;
};
export type Change = "edited" | "reverted" | "";
export type SettingsChanges = {
  [category: string]: {
    [subcategory: string]: {
      [collection: string]: {
        [setting: string]: Change;
      };
    };
  };
};

export const settingChanged = createStandardAction("SETTING_CHANGED")<
  SettingChangePayload
>();
export const resetChanges = createStandardAction("RESET_CHANGES")();

const SettingsActions = { settingChanged, resetChanges };
export type SettingsAction = ActionType<typeof SettingsActions>;

const defaultSettingsState: SettingsChanges = {};

export const SettingsReducer = createReducer(defaultSettingsState)
  .handleAction(settingChanged, (state, action) => {
    const {
      category,
      subcategory,
      collection,
      settingName,
      change
    } = action.payload;
    const subcategories = state[category] || {};
    const collections = subcategories[subcategory] || {};
    const settingChanges = collections[collection] || {};
    // only update state if needed
    if (change !== settingChanges[settingName]) {
      if (change) {
        // add change to state
        return {
          ...state,
          [category]: {
            ...subcategories,
            [subcategory]: {
              ...collections,
              [collection]: {
                ...settingChanges,
                [settingName]: change
              }
            }
          }
        };
      } else {
        // delete change from state (and delete empty objects along path if any)
        const newState = _.cloneDeep(state);
        _.unset(newState, [category, subcategory, collection, settingName]);

        let path = [category, subcategory, collection];
        while (path.length > 0) {
          if (_.isEmpty(_.get(newState, path))) {
            _.unset(newState, path);
            path.pop();
          } else {
            // no need to check further
            path.length = 0;
          }
        }

        return newState;
      }
    }

    return state;
  })
  .handleAction(resetChanges, (state, action) => defaultSettingsState);

export type SettingsState = StateType<typeof SettingsReducer>;
